export default __webpack_public_path__ + "static/media/burritos.cb3975de.jpeg";